import { render } from "./ColumnsList.vue?vue&type=template&id=72575a32&scoped=true"
import script from "./ColumnsList.vue?vue&type=script&lang=js"
export * from "./ColumnsList.vue?vue&type=script&lang=js"

import "./ColumnsList.vue?vue&type=style&index=0&id=72575a32&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-72575a32"

export default script